import styled from 'styled-components'
import media from 'styled-media-query'

export const ContainerLogo = styled.div`
  display: block;
  padding: 0 1.5rem;
  grid-area: logo;

  ${media.lessThan('medium')`
    justify-content: center;
    display: flex;
    padding: 0;
    margin: 0 2rem 2rem;;
  `}
`
export const ImgLogo = styled.img`
  position: absolute;
  left: 24px;
  top: 17px;

  @media only screen and (max-width: 767px) {
    position: absolute;
    left: 16px;
    top: 20px;
  }

`
